// extracted by mini-css-extract-plugin
module.exports = {"container":"LiveCountdown_container__c8sM-","timeToStartContainer":"LiveCountdown_timeToStartContainer__3XGwo","typographyCountdown":"LiveCountdown_typographyCountdown__I7qXl"};